import { connect } from 'react-redux';
import toJSComponent from 'with-immutable-props-to-js';
import { reduxForm, Field } from 'redux-form/immutable';
import { Button, Grid, DialogActions } from '@material-ui/core';

import {
  createLesson,
  onCreateLessonModalLoaded,
} from 'features/projects/lessons/lessons.actions';

import {
  MODAL,
  CREATE_LESSON_FORM,
} from 'features/projects/lessons/lessons.constants';

import { required } from 'utils/validation.util';
import TextField from 'app/components/form/TextField';
import LoadingButton from 'app/components/LoadingButton';
import ModalContainer from 'app/components/Modal/ModalContainer';
import EditorReduxForm from 'app/components/form/EditorField';

const CreateLessonModalContainer = ({
  valid,
  children,
  submitting,
  handleSubmit,
  dispatchOnLoad,
}) => (
  <ModalContainer
    height="auto"
    title="Create lesson"
    onEnter={dispatchOnLoad}
    TriggerComponent={children}
    modalId={MODAL.CREATE_LESSON}
    Actions={({ toggleModal }) => (
      <DialogActions>
        <Button onClick={toggleModal} size="small">
          Cancel
        </Button>
        <LoadingButton
          type="submit"
          size="small"
          color="primary"
          disabled={!valid}
          variant="contained"
          onClick={handleSubmit}
          submitting={submitting}
          form={CREATE_LESSON_FORM.ID}
        >
          Create
        </LoadingButton>
      </DialogActions>
    )}
  >
    <form id={CREATE_LESSON_FORM.ID} onSubmit={handleSubmit}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <Field
            required
            autoFocus
            label="Title"
            component={TextField}
            validate={[required]}
            name={CREATE_LESSON_FORM.TITLE}
            inputProps={{ maxLength: 100 }}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            required
            label="Description"
            component={EditorReduxForm}
            validate={[required]}
            name={CREATE_LESSON_FORM.DESCRIPTION}
            xs={12}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            component={EditorReduxForm}
            label="Recommended actions"
            name={CREATE_LESSON_FORM.RECOMMENDED_ACTIONS}
            xs={12}
          />
        </Grid>
      </Grid>
    </form>
  </ModalContainer>
);

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchOnLoad: () => dispatch(onCreateLessonModalLoaded()),
  onSubmit: () => dispatch(createLesson(ownProps.project.id)),
});

export default connect(
  null,
  mapDispatchToProps,
)(
  toJSComponent(
    reduxForm({
      form: CREATE_LESSON_FORM.ID,
    })(CreateLessonModalContainer),
  ),
);
